import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

const mintsoftReasonMapEntry = z.object({
  redoReason: z.string().trim(),
  mintsoftReasonId: z.number().int(),
  mintsoftReasonName: z.string(),
});

export const mintsoftSettings = defineIntegrationSettings({
  fields: {
    username: z.string().trim().min(1).nullable(),
    clientId: z.number().int().min(1, "Client ID must be a positive integer"),
    returnReasonMap: z.array(mintsoftReasonMapEntry),
    defaultReturnReasonId: z.number().int().min(0),
    defaultReturnReasonName: z.string(),
  },
  secrets: {
    apiKey: z.string().trim().min(1).optional(),
    password: z.string().min(1).optional(),
  },
  connectOnly: {},
  computed: {},
});
